
import * as React from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import services from '../../../services';
import { $ } from 'jquery';
import Swal from 'sweetalert2';


export const NumericCell = props => {
    const handleChange = e => {
        if (props.onChange) {
          props.onChange({
            dataIndex: 0,
            dataItem: props.dataItem,
            field: props.field,
            syntheticEvent: e.syntheticEvent,
            value: e.target.value
          });

         
        }
      };
      
      const {
        dataItem
      } = props;
      const field = props.field || '';
      var dataValue = dataItem[field] === null ? '' : dataItem[field];

      var indexId = dataItem.ProductID;
      if(dataItem.inEdit == true){
        indexId = 0
      }
      console.log(field)
      if(field == "Capacidade_comunicada"){

        if(document.getElementsByClassName("capacidadecomunicada")[indexId] != undefined){
          dataItem[field] = document.getElementsByClassName("capacidadecomunicada")[indexId].value
          dataValue = document.getElementsByClassName("capacidadecomunicada")[indexId].value
        }  

        return <td>
        {dataItem.inEdit ? <input type="text" id='numberboxcell' className='capacidadecomunicada' onChange={handleChange} value={dataValue != null ? dataValue : undefined} disabled /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          </td>
      }
      if(field == "NGarrafasDevolvidas"){
        if(document.getElementsByClassName("NGarrafasDevolvidas")[indexId] != undefined && document.getElementsByClassName("CapacidadeCell")[indexId] != undefined){
          var numerogarrafas = document.getElementsByClassName("NGarrafasDevolvidas")[indexId].value;
          var capacidadeQNTFinal = document.getElementsByClassName("CapacidadeCell")[indexId].outerText;
            if(capacidadeQNTFinal != '' && capacidadeQNTFinal != undefined && numerogarrafas != "" && numerogarrafas != undefined){
              var contaQtdFinal = parseFloat(parseInt(numerogarrafas) * parseFloat(capacidadeQNTFinal));
              document.getElementsByClassName("QtdFinal")[indexId].value = String(contaQtdFinal);
              document.getElementsByClassName("QtdFinal")[indexId].text = String(contaQtdFinal);
              dataItem.QtdFinal = String(contaQtdFinal);
            }
           
        }  
      }
      if(field == "NGarrafas"){
        if(document.getElementsByClassName("NGarrafasND")[indexId] != undefined && dataItem.CapacidadeND != undefined ){
          var numerogarrafas = document.getElementsByClassName("NGarrafasND")[indexId].value;
          var capacidadeQNTFinal = dataItem.CapacidadeND != undefined && dataItem.CapacidadeND != "" ? parseFloat(parseFloat(dataItem.CapacidadeND.text) / 100) : dataItem.CapacidadeND;
          if(document.getElementsByClassName("CorrelativaND")[indexId] != undefined){
            var capacidadeCorrelativa = document.getElementsByClassName("CorrelativaND")[indexId].outerText;
          }
          
          if(capacidadeCorrelativa != undefined && capacidadeCorrelativa != "" && numerogarrafas != "" && numerogarrafas != undefined){
            var capacidadeCorre = parseFloat(parseFloat(capacidadeCorrelativa.split(" - ")[3]) / 100);
            
            var conta = parseFloat(capacidadeCorre/parseInt(numerogarrafas));
            document.getElementsByClassName("TotalQBDND")[indexId].value = String(conta);
            document.getElementsByClassName("TotalQBDND")[indexId].text = String(conta);
            dataItem.TotalQBD = String(conta);
          }
          if(capacidadeQNTFinal != '' && capacidadeQNTFinal != undefined && numerogarrafas != "" && numerogarrafas != undefined && dataItem.CapacidadeND != ""){
            var contaQtdFinal = parseFloat(parseInt(numerogarrafas) * parseFloat(capacidadeQNTFinal));
            document.getElementsByClassName("TotalQBDND")[indexId].value = String(contaQtdFinal);
            document.getElementsByClassName("TotalQBDND")[indexId].text = String(contaQtdFinal);
            dataItem.TotalQBD = String(contaQtdFinal);
          }
        }  
        return <td>
          {dataItem.inEdit ? <input type="text" id='numberboxcell' className='NGarrafasND' onChange={handleChange} value={dataValue != null ? dataValue : undefined} /> 
            : (dataValue != null ?  dataValue.toString() : undefined)}
        </td>
        
      }
      if(field == "Falta_granel"){
        if(document.getElementsByClassName("falta")[indexId] != undefined){
          dataItem[field] = document.getElementsByClassName("falta")[indexId].value
          dataValue = document.getElementsByClassName("falta")[indexId].value
        }  
        return <td>
          {dataItem.inEdit ? <input type="text" id='numberboxcell' className='falta' onChange={handleChange} value={dataValue != null ? dataValue : undefined} disabled /> //disabled={dataValue != "" ? "true" : ""} /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          </td>
      }

      if(field == "Falta"){
        if(document.getElementsByClassName("falta")[indexId] != undefined ){
          dataItem[field] = document.getElementsByClassName("falta")[indexId].value
          dataValue = document.getElementsByClassName("falta")[indexId].value
        }  
        return <td>
          {dataItem.inEdit ? <input type="text" id='numberboxcell' className='falta' onChange={handleChange} value={dataValue != null ? dataValue : undefined} disabled /> //disabled={dataValue != "" ? "true" : ""} /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          </td>
      }

      if(field == "Altura"){
        if(document.getElementsByClassName("Altura")[indexId] != undefined){
          dataItem[field] = document.getElementsByClassName("Altura")[indexId].value
          dataValue = document.getElementsByClassName("Altura")[indexId].value
        }  
        return <td>
          {dataItem.inEdit ? <input type="text" id='numberboxcell' className='Altura' onChange={handleChange} value={dataValue != null ? dataValue : undefined} disabled /> //disabled={dataValue != "" ? "true" : ""} /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          </td>
      }

      if(field == "IndispGranelQA"){

        if(document.getElementsByClassName("IndispGranelQA")[indexId] != undefined){
          dataItem[field] = document.getElementsByClassName("IndispGranelQA")[indexId].value
          dataValue = document.getElementsByClassName("IndispGranelQA")[indexId].value
        }  

        return <td>
        {dataItem.inEdit ? <input type="number" id='numberboxcell' className='IndispGranelQA' onChange={handleChange} value={dataValue != null ? dataValue : undefined}  /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          </td>
      }
      if(field == "IndispEngaQA"){

        if(document.getElementsByClassName("IndispEngaQA")[indexId] != undefined){
          dataItem[field] = document.getElementsByClassName("IndispEngaQA")[indexId].value
          dataValue = document.getElementsByClassName("IndispEngaQA")[indexId].value
        }  

        return <td>
        {dataItem.inEdit ? <input type="number" id='numberboxcell' className='IndispEngaQA' onChange={handleChange} value={dataValue != null ? dataValue : undefined}  /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          </td>
      }
      if(field == "ProdutoAcabadoQA"){

        if(document.getElementsByClassName("ProdutoAcabadoQA")[indexId] != undefined){
          dataItem[field] = document.getElementsByClassName("ProdutoAcabadoQA")[indexId].value
          dataValue = document.getElementsByClassName("ProdutoAcabadoQA")[indexId].value
        }  

        return <td>
        {dataItem.inEdit ? <input type="number" id='numberboxcell' className='ProdutoAcabadoQA' onChange={handleChange} value={dataValue != null ? dataValue : undefined} /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          </td>
      }
      if(field == "VendasQA"){

        if(document.getElementsByClassName("VendasQA")[indexId] != undefined){
          dataItem[field] = document.getElementsByClassName("VendasQA")[indexId].value
          dataValue = document.getElementsByClassName("VendasQA")[indexId].value
        }  

        return <td>
        {dataItem.inEdit ? <input type="number" id='numberboxcell' className='VendasQA' onChange={handleChange} value={dataValue != null ? dataValue : undefined}  /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          </td>
      }
      // if(field == "VasilhaOtrasEnt"){
      //   return <td>
      //   {dataItem.inEdit ? <input type="checkbox" id='numberboxcell' className='VasilhaOtrasEnt' onChange={handleChange} value={dataValue != null ? dataValue : undefined} /> 
      //     : ($(".VasilhaOtrasEnt").is("checked") ? $(".VasilhaOtrasEnt").is("checked").toString() : undefined)}
      //     </td>
      // }
      if(field == "IndispGranelQT"){
        return <td>
        {dataItem.inEdit ? <input type="number" id='numberboxcell' className='IndispGranelQT' onChange={handleChange} value={dataValue != null ? dataValue : undefined} disabled /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          </td>
      }
      if(field == "ProdutoAcabadoQT"){
        return <td>
        {dataItem.inEdit ? <input type="number" id='numberboxcell' className='ProdutoAcabadoQT' onChange={handleChange} value={dataValue != null ? dataValue : undefined} disabled /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          </td>
      }
      if(field == "TotalQT"){
        return <td>
        {dataItem.inEdit ? <input type="number" id='numberboxcell' className='TotalQT' onChange={handleChange} value={dataValue != null ? dataValue : undefined} disabled /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          </td>
      }
      if(field == "IndispEngaQT"){
        return <td>
        {dataItem.inEdit ? <input type="number" id='numberboxcell' className='IndispEngaQT' onChange={handleChange} value={dataValue != null ? dataValue : undefined} disabled /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          </td>
      }
      if(field == "TotalQBD"){
        return <td>
        {dataItem.inEdit ? <input type="number" id='numberboxcell' className='TotalQBD' onChange={handleChange} value={dataValue != null ? dataValue : undefined} disabled /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          </td>
      }
      if(field == "ProdutoAcabadoQBD"){
        return <td>
        {dataItem.inEdit ? <input type="number" id='numberboxcell' className='ProdutoAcabadoQBD' onChange={handleChange} value={dataValue != null ? dataValue : undefined} disabled /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          </td>
      }
      if(field == "IndispEngaQBD"){
        return <td>
        {dataItem.inEdit ? <input type="number" id='numberboxcell' className='IndispEngaQBD' onChange={handleChange} value={dataValue != null ? dataValue : undefined} disabled /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          </td>
      }
      if(field == "IndispGranelQBD"){
        return <td>
        {dataItem.inEdit ? <input type="number" id='numberboxcell' className='IndispGranelQBD' onChange={handleChange} value={dataValue != null ? dataValue : undefined} disabled /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          </td>
      }
      if(field == "TotalQA"){
        return <td>
        {dataItem.inEdit ? <input type="number" id='numberboxcell' className='TotalQA' onChange={handleChange} value={dataValue != null ? dataValue : undefined} disabled /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          </td>
      }
      if(field == "DocEntrada"){
        return <td>
        {dataItem.inEdit ? <input type="date" id='numberboxcell' className='DocEntrada' onChange={handleChange} value={dataValue != null ? dataValue : undefined} /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          </td>
      }
      if(field == "DataVendas"){
        return <td>
        {dataItem.inEdit ? <input type="date" id='numberboxcell' className='DataVendas' onChange={handleChange} value={dataValue != null ? dataValue : undefined} /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          </td>
      }
      
      if(field == "QTSelosCarteira"){
        // if(document.getElementsByClassName("QTSelosCarteira")[indexId] != undefined){
        //   dataItem[field] = document.getElementsByClassName("QTSelosCarteira")[indexId].value
        //   dataValue = document.getElementsByClassName("QTSelosCarteira")[indexId].value
        // }  

        return <td>
        {dataItem.inEdit ? <input type="number" id='numberboxcell' className='QTSelosCarteira' onChange={handleChange} value={dataValue != null ? dataValue : undefined} disabled /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          </td>
      }
      if(field == "ProdutoAcabado"){
        // if(document.getElementsByClassName("ProdutoAcabado")[indexId] != undefined){
        //   dataItem[field] = document.getElementsByClassName("ProdutoAcabado")[indexId].value
        //   dataValue = document.getElementsByClassName("ProdutoAcabado")[indexId].value
        // }  

        return <td>
        {dataItem.inEdit ? <input type="number" id='numberboxcell' className='ProdutoAcabado' onChange={handleChange} value={dataValue != null ? dataValue : undefined} /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          </td>
      }
      if(field == "NumeroGarrafasVendas"){
        // if(document.getElementsByClassName("NumeroGarrafasVendas")[indexId] != undefined){
        //   dataItem[field] = document.getElementsByClassName("NumeroGarrafasVendas")[indexId].value
        //   dataValue = document.getElementsByClassName("NumeroGarrafasVendas")[indexId].value
        // }  

        return <td>
        {dataItem.inEdit ? <input type="number" id='numberboxcell' className='NumeroGarrafasVendas' onChange={handleChange} value={dataValue != null ? dataValue : undefined} /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          </td>
      }
      if(field == "VolumeVendas"){
        // if(document.getElementsByClassName("VolumeVendas")[indexId] != undefined){
        //   dataItem[field] = document.getElementsByClassName("VolumeVendas")[indexId].value
        //   dataValue = document.getElementsByClassName("VolumeVendas")[indexId].value
        // }  

        return <td>
        {dataItem.inEdit ? <input type="number" id='numberboxcell' className='VolumeVendas' onChange={handleChange} value={dataValue != null ? dataValue : undefined} disabled /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          </td>
      }
      if(field == "IndisponivelEngarrafado"){
        // if(document.getElementsByClassName("IndispEngarrafado")[indexId] != undefined){
        //   dataItem[field] = document.getElementsByClassName("IndispEngarrafado")[indexId].value
        //   dataValue = document.getElementsByClassName("IndispEngarrafado")[indexId].value
        // }  

        return <td>
        {dataItem.inEdit ? <input type="number" id='numberboxcell' className='IndispEngarrafado' onChange={handleChange} value={dataValue != null ? dataValue : undefined} /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          </td>

      }
      if(field == "DocSaida"){
        if(dataItem.DocSaida > dataItem.DocEntrada){
          Swal.fire({
            icon: 'error',
            title: 'Dados inválidos',
            text: 'A data de saída tem de ser anterior à data de entrada',
          })
          return <td>
        {dataItem.inEdit ? <input type="date" id='numberboxcell' className='DocSaida' onChange={handleChange} value={dataValue != null ? "" : undefined} /> 
          :  (dataValue != null ?  dataValue.toString() : undefined)}
          </td>
        }else{
          return <td>
          {dataItem.inEdit ? <input type="date" id='numberboxcell' className='DocSaida' onChange={handleChange} value={dataValue != null ? dataValue : undefined} /> 
            : (dataValue != null ?  dataValue.toString() : undefined)}
            </td>
        }
      }
      // if(field == "Produto_Selos"){
      //   if(document.getElementsByClassName("Produto_Selos")[indexId] != undefined){
      //     dataItem[field] = document.getElementsByClassName("Produto_Selos")[indexId].value
      //     dataValue = document.getElementsByClassName("Produto_Selos")[indexId].value
      //   }  
      //   return <td>
      //     {dataItem.inEdit ? <input type="text" id='numberboxcell' className='Produto_Selos' onChange={handleChange} value={dataValue != null ? dataValue : undefined} disabled /> //disabled={dataValue != "" ? "true" : ""} /> 
      //     : (dataValue != null ?  dataValue.toString() : undefined)}
      //     </td>
      // }
      if(field == "QuantidadeApurada"){
        if(document.getElementsByClassName("Quantidade_apurada")[indexId] != undefined ){
          dataItem[field] = document.getElementsByClassName("Quantidade_apurada")[indexId].value
          dataValue = document.getElementsByClassName("Quantidade_apurada")[indexId].value
        }  
        return <td>
          {dataItem.inEdit ? <input type="text" id='numberboxcell' className='Quantidade_apurada' onChange={handleChange} value={dataValue != null ? dataValue : undefined} disabled /> //disabled={dataValue != "" ? "true" : ""} /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          </td>
      }
      if(field == "Quantidade_apurada"){
        if(document.getElementsByClassName("Quantidade_apurada")[indexId] != undefined){
          dataItem[field] = document.getElementsByClassName("Quantidade_apurada")[indexId].value
          dataValue = document.getElementsByClassName("Quantidade_apurada")[indexId].value
        }  
        return <td>
          {dataItem.inEdit ? <input type="text" id='numberboxcell' className='Quantidade_apurada' onChange={handleChange} value={dataValue != null ? dataValue : undefined} disabled /> //disabled={dataValue != "" ? "true" : ""} /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          </td>
      }
      if(field == "Capacidade_aferida"){

        if(document.getElementsByClassName("capacidadeaferida")[indexId] != undefined ){
          dataItem[field] = document.getElementsByClassName("capacidadeaferida")[indexId].value
          dataValue = document.getElementsByClassName("capacidadeaferida")[indexId].value
        }  
        return <td>
          {dataItem.inEdit ? <input type="text" id='numberboxcell' className='capacidadeaferida' onChange={handleChange} value={dataValue != null ? dataValue : undefined} disabled /> //disabled={dataValue != "" ? "true" : ""} /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          </td>
      }
      if(field == "Quantidade_selosGarantia"){
        if(document.getElementsByClassName("QuantidadeSelos")[indexId] != undefined){
          dataItem[field] = document.getElementsByClassName("QuantidadeSelos")[indexId].value
          dataValue = document.getElementsByClassName("QuantidadeSelos")[indexId].value
        }
          return <td>
          {dataItem.inEdit ? <input type="text" id='numberboxcell' className='QuantidadeSelos' onChange={handleChange} value={dataValue != null ? dataValue : undefined} /> //disabled={dataValue != "" ? "true" : ""} /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          </td>
      }
      if(field == "NGarrafasIVDP"){
        return <td>
          {dataItem.inEdit ? <input type="text" id='numberboxcell' className='NGarrafasIVDP' onChange={handleChange} value={dataValue != null ? dataValue : undefined} /> //disabled={dataValue != "" ? "true" : ""} /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          </td>
      }
      if(field == "NumeroVendas"){
        return <td>
          {dataItem.inEdit ? <input type="number" id='numberboxcell' className='NumeroVendas' onChange={handleChange} value={dataValue != null ? dataValue : undefined} /> //disabled={dataValue != "" ? "true" : ""} /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          </td>
      }
      
      if(field == "NGarrafasVist"){
        return <td>
          {dataItem.inEdit ? <input type="text" id='numberboxcell' className='NGarrafasIVDP' onChange={handleChange} value={dataValue != null ? dataValue : undefined} /> //disabled={dataValue != "" ? "true" : ""} /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          </td>
      }
      if(field == "NGarrafasAE"){
        return <td>
          {dataItem.inEdit ? <input type="text" id='numberboxcell' className='NGarrafasAE' onChange={handleChange} value={dataValue != null ? dataValue : undefined} /> //disabled={dataValue != "" ? "true" : ""} /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          </td>
      }
      if(field == "NGarrafasDevolvidas"){
        return <td>
          {dataItem.inEdit ? <input type="text" id='numberboxcell' className='NGarrafasDevolvidas' onChange={handleChange} value={dataValue != null ? dataValue : undefined} /> //disabled={dataValue != "" ? "true" : ""} /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          </td>
      }

      if(field == "QtdFinal"){
        return <td>
          {dataItem.inEdit ? <input type="text" id='numberboxcell' className='QtdFinal' onChange={handleChange} value={dataValue != null ? dataValue : undefined} disabled /> //disabled={dataValue != "" ? "true" : ""} /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          </td>
      }
      
      if(field == "N_Garrafas_IVDP"){
        return <td>
          {dataItem.inEdit ? <input type="text" id='numberboxcell' className='NGarrafasIVDP' onChange={handleChange} value={dataValue != null ? dataValue : undefined} /> //disabled={dataValue != "" ? "true" : ""} /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          </td>
      }
      if(field == "N_Garrafas_AE"){
        return <td>
          {dataItem.inEdit ? <input type="text" id='numberboxcell' className='NGarrafasAE' onChange={handleChange} value={dataValue != null ? dataValue : undefined} /> //disabled={dataValue != "" ? "true" : ""} /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          
          </td>
      }
      if(field == "NGarrafasAmostra"){
        if(dataItem.MotivoDispensa != undefined && dataItem.MotivoDispensa.value != null){
          dataItem.NGarrafasAmostra = "";
          dataValue = "";
          return <td>
          {dataItem.inEdit ? <input type="text" id='numberboxcell' className='NGarrafasAmostra' onChange={handleChange} value={dataValue != null ? dataValue : undefined} /> //disabled={dataValue != "" ? "true" : ""} /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          
          </td>
        }else{
          return <td>
          {dataItem.inEdit ? <input type="text" id='numberboxcell' className='NGarrafasAmostra' onChange={handleChange} value={dataValue != null ? dataValue : undefined} /> //disabled={dataValue != "" ? "true" : ""} /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          
          </td>
        }
       
      }
      if(field == "Volume_engarrafado"){
        return <td>
        {dataItem.inEdit ? <input type="text" id='numberboxcell' className='VolumeEngarrafado' onChange={handleChange} value={dataValue != null ? dataValue : undefined} disabled /> //disabled={dataValue != "" ? "true" : ""} /> 
        : (dataValue != null ?  dataValue.toString() : undefined)}
        </td>
      }
      if(field == "QuantidadeApuradaEngarrafado"){
        return <td>
        {dataItem.inEdit ? <input type="text" id='numberboxcell' className='QuantidadeApuradaEngarrafado' onChange={handleChange} value={dataValue != null ? dataValue : undefined} disabled /> //disabled={dataValue != "" ? "true" : ""} /> 
        : (dataValue != null ?  dataValue.toString() : undefined)}
        </td>
      }
      if(field == "Produto_Selos"){
        if(document.getElementsByClassName("ProdutoSelos") != undefined){
          if(document.getElementsByClassName("ProdutoSelos")[indexId] != undefined){
            dataItem[field] = document.getElementsByClassName("ProdutoSelos")[indexId].value
            dataValue = document.getElementsByClassName("ProdutoSelos")[indexId].value
            return <td>
            {dataItem.inEdit ? <input type="text" id='numberboxcell' className='ProdutoSelos' onChange={handleChange} value={dataValue != null ? dataValue : undefined} disabled /> //disabled={dataValue != "" ? "true" : ""} /> 
            : (dataValue != null ?  dataValue.toString() : undefined)}
            </td>
           
          }else if(document.getElementsByClassName("ProdutoSelos")[indexId-1] != undefined && dataValue == ""){
            dataItem[field] = document.getElementsByClassName("ProdutoSelos")[indexId-1].value
            dataValue = document.getElementsByClassName("ProdutoSelos")[indexId-1].value
            return <td>
            {dataItem.inEdit ? <input type="text" id='numberboxcell' className='ProdutoSelos' onChange={handleChange} value={dataValue != null ? dataValue : undefined} disabled /> //disabled={dataValue != "" ? "true" : ""} /> 
            : (dataValue != null ?  dataValue.toString() : undefined)}
            </td>
          } else{
            return <td>
            {dataItem.inEdit ? <input type="text" id='numberboxcell' className='ProdutoSelos' onChange={handleChange} value={dataValue != null ? dataValue : undefined} disabled /> //disabled={dataValue != "" ? "true" : ""} /> 
            : (dataValue != null ?  dataValue.toString() : undefined)}
            </td>
          }
        }else{
          return <td>
          {dataItem.inEdit ? <input type="text" id='numberboxcell' className='ProdutoSelos' onChange={handleChange} value={dataValue != null ? dataValue : undefined} disabled /> //disabled={dataValue != "" ? "true" : ""} /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          </td>
        }
        

        
      }
     
      if(field == "Quantidade_aferida"){

        if(document.getElementsByClassName("capacidadeaferida")[indexId] != undefined){
          dataItem[field] = document.getElementsByClassName("capacidadeaferida")[indexId].value
          dataValue = document.getElementsByClassName("capacidadeaferida")[indexId].value
        }  
        return <td>
          {dataItem.inEdit ? <input type="text" id='numberboxcell' className='capacidadeaferida' onChange={handleChange} value={dataValue != null ? dataValue : undefined} disabled /> //disabled={dataValue != "" ? "true" : ""} /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          </td>
      }else{
        return <td>
          {dataItem.inEdit ? <input type="number" id="numberboxcell"  onChange={handleChange} value={parseFloat(dataValue) != null ? parseFloat(dataValue) : undefined} /> 
          : (dataValue != null ?  dataValue.toString() : undefined)}
          </td>
      }

      
      
      
      
}